import { useEffect, useRef } from "react";
import type { Channel } from "pusher-js";

export const useEvent = (
	channel: Channel | null,
	eventName: string,
	callback: (data?: any) => void,
): void => {
	// Use ref to store stable callback reference
	const callbackRef = useRef(callback);

	// Update ref when callback changes
	useEffect(() => {
		callbackRef.current = callback;
	}, [callback]);

	useEffect(() => {
		if (!channel) return;

		// Wrapper function that calls the current callback
		const eventHandler = (data?: any) => {
			callbackRef.current(data);
		};

		// Bind event
		channel.bind(eventName, eventHandler);

		// Cleanup
		return () => {
			channel.unbind(eventName, eventHandler);
		};
	}, [channel, eventName]);
};
